import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 30px 0 24px 26px;
  border-bottom-width: 1px;
  border-bottom-color: #d0dade;
  flex-direction: row;
  width: 100%;
  background-color: #ffffff;
`;

export const Title = styled.p`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
`;

export const GoBackIcon = styled.a`
  margin-right: 20px;
`;
